/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Watch_BoxInputs */

const en_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch & Box`)
};

const es_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reloj y Caja`)
};

const fr_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montre & Boîte`)
};

const de_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhr & Box`)
};

const ja_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計と箱`)
};

const zh_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手表 & 表盒`)
};

const ar_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الساعة والعلبة`)
};

const id_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam & Kotak`)
};

const it_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orologio & Scatola`)
};

const ru_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы и Коробка`)
};

const pt_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relógio e Caixa`)
};

const ko_val_watch_box = /** @type {(inputs: Val_Watch_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시계 및 상자`)
};

/**
* | output |
* | --- |
* | "Watch & Box" |
*
* @param {Val_Watch_BoxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_watch_box = /** @type {((inputs?: Val_Watch_BoxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Watch_BoxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_watch_box(inputs)
	if (locale === "es") return es_val_watch_box(inputs)
	if (locale === "fr") return fr_val_watch_box(inputs)
	if (locale === "de") return de_val_watch_box(inputs)
	if (locale === "ja") return ja_val_watch_box(inputs)
	if (locale === "zh") return zh_val_watch_box(inputs)
	if (locale === "ar") return ar_val_watch_box(inputs)
	if (locale === "id") return id_val_watch_box(inputs)
	if (locale === "it") return it_val_watch_box(inputs)
	if (locale === "ru") return ru_val_watch_box(inputs)
	if (locale === "pt") return pt_val_watch_box(inputs)
	return ko_val_watch_box(inputs)
});